import React from 'react';
import { Link } from 'react-router-dom';
const Footer = () => {
  return <footer className="bg-amber-900 text-white" data-id="element-87">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-88">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8" data-id="element-89">
          <div data-id="element-90">
            <h2 className="text-xl font-bold mb-4" data-id="element-91">
              Jose's Kare kare and Bulalo House
            </h2>
            <p className="text-amber-100" data-id="element-92">
              AI-powered food ordering system that personalizes your dining
              experience.
            </p>
          </div>
          <div data-id="element-93">
            <h3 className="text-lg font-semibold mb-4" data-id="element-94">Quick Links</h3>
            <ul className="space-y-2" data-id="element-95">
              <li data-id="element-96">
                <Link to="/" className="text-amber-100 hover:text-white" data-id="element-97">
                  Home
                </Link>
              </li>
              <li data-id="element-98">
                <Link to="/menu" className="text-amber-100 hover:text-white" data-id="element-99">
                  Menu
                </Link>
              </li>
              <li data-id="element-100">
                <Link to="/about" className="text-amber-100 hover:text-white" data-id="element-101">
                  About Us
                </Link>
              </li>
              <li data-id="element-102">
                <Link to="/contact" className="text-amber-100 hover:text-white" data-id="element-103">
                  Contact
                </Link>
              </li>
            </ul>
          </div>
          <div data-id="element-104">
            <h3 className="text-lg font-semibold mb-4" data-id="element-105">Customer Support</h3>
            <ul className="space-y-2" data-id="element-106">
              <li data-id="element-107">
                <Link to="/faq" className="text-amber-100 hover:text-white" data-id="element-108">
                  FAQ
                </Link>
              </li>
              <li data-id="element-109">
                <Link to="/terms" className="text-amber-100 hover:text-white" data-id="element-110">
                  Terms of Service
                </Link>
              </li>
              <li data-id="element-111">
                <Link to="/privacy" className="text-amber-100 hover:text-white" data-id="element-112">
                  Privacy Policy
                </Link>
              </li>
              <li data-id="element-113">
                <Link to="/help" className="text-amber-100 hover:text-white" data-id="element-114">
                  Help Center
                </Link>
              </li>
            </ul>
          </div>
          <div data-id="element-115">
            <h3 className="text-lg font-semibold mb-4" data-id="element-116">Contact Us</h3>
            <address className="not-italic text-amber-100" data-id="element-117">
              <p data-id="element-118">205 A. Arnaiz St. Libertad</p>
              <p data-id="element-119">Pasay City, Philippines</p>
              <p className="mt-2" data-id="element-120">Phone: 09079222970</p>
              <p data-id="element-121">Email: info@joseskarekare.com</p>
              <div className="mt-4" data-id="element-122">
                <Link to="/contact" className="text-white hover:text-amber-200 underline" data-id="element-123">
                  View on Map
                </Link>
              </div>
            </address>
          </div>
        </div>
        <div className="mt-8 pt-8 border-t border-amber-700" data-id="element-124">
          <div className="flex flex-col md:flex-row md:justify-between items-center" data-id="element-125">
            <p className="text-center text-amber-100 mb-4 md:mb-0" data-id="element-126">
              &copy; {new Date().getFullYear()} Jose's Kare kare and Bulalo
              House. All rights reserved.
            </p>
            <div className="flex space-x-4" data-id="element-127">
              <a href="#" className="text-amber-100 hover:text-white" data-id="element-128">
                <span className="sr-only" data-id="element-129">Facebook</span>
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" data-id="element-130">
                  <path fillRule="evenodd" d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" clipRule="evenodd" data-id="element-131" />
                </svg>
              </a>
              <a href="#" className="text-amber-100 hover:text-white" data-id="element-132">
                <span className="sr-only" data-id="element-133">Instagram</span>
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" data-id="element-134">
                  <path fillRule="evenodd" d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z" clipRule="evenodd" data-id="element-135" />
                </svg>
              </a>
              <a href="#" className="text-amber-100 hover:text-white" data-id="element-136">
                <span className="sr-only" data-id="element-137">Twitter</span>
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" data-id="element-138">
                  <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" data-id="element-139" />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>;
};
export default Footer;